import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {CarouselContent, useCarousel} from '@/components/ui/carousel'
import Question from './goalQuestion'
import {questionPropType} from './utils'

const GoalQuestionnaireContent = ({
    questions,
    setQuestions,
    addQuestion,
    goal,
    setGoal,
    isMobile,
    isGuest
}) => {
    const {scrollNext, api} = useCarousel()
    const [isNextQuestionLoading, setIsNextQuestionLoading] = useState(false)

    useEffect(() => {
        if (api) {
            api.on('slidesChanged', () => {
                setIsNextQuestionLoading(true)
                setTimeout(() => {
                    scrollNext()
                    setIsNextQuestionLoading(false)
                }, 300)
            })
        }
    }, [api, scrollNext])

    return (
        <CarouselContent
            className="mx-auto mt-4"
            data-testid="goalQuestionnaireContent-CarouselContent"
        >
            {questions.map((question, questionId) => (
                <Question
                    goal={goal}
                    setGoal={setGoal}
                    question={question}
                    questions={questions}
                    setQuestions={setQuestions}
                    addQuestion={addQuestion}
                    key={questionId}
                    isMobile={isMobile}
                    isGuest={isGuest}
                    isNextQuestionLoading={isNextQuestionLoading}
                    data-testid="goalQuestionnaireContent"
                />
            ))}
        </CarouselContent>
    )
}

GoalQuestionnaireContent.propTypes = {
    questions: PropTypes.arrayOf(questionPropType),
    goal: PropTypes.object || null,
    setGoal: PropTypes.func.isRequired,
    addQuestion: PropTypes.func.isRequired,
    setQuestions: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isGuest: PropTypes.bool.isRequired
}

export default GoalQuestionnaireContent
